import { apiRequest } from "../util/apiUtils";

export const addRaisedDispute = async (params) => {
  try {
    const res = await apiRequest(
      "post",
      `milestone/dispute`,
      {
        body: params,
      },
      "multipart/form-data"
    );
    return res?.data;
  } catch (error) {
    return error;
  }
};
